export default {
  'advertImage': 'Объявление',
  'image_id': 'Изображение'
}
